/**
 * Route for `auto-debit-billing-stripe-card-on-file-for-platform-fees`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoDebitBillingStripeCardOnFileForPlatformFeesPage } from "../features/auto-debit-billing-stripe-card-on-file-for-platform-fees/AutoDebitBillingStripeCardOnFileForPlatformFeesPage";

export const autoDebitBillingStripeCardOnFileForPlatformFeesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-debit-billing-stripe-card-on-file-for-platform-fees",
	component: AutoDebitBillingStripeCardOnFileForPlatformFeesPage,
});

export default autoDebitBillingStripeCardOnFileForPlatformFeesRoute;
